/**
 * ROUTE MANIFEST — the only file that knows where a lane's pages are mounted.
 *
 * Each feature module default-exports a component that renders its own <Routes> relative to
 * its base path, so L4 (governance, admin) and L5 (library) add pages by editing files inside
 * their own directory only. Nothing here changes when a page is added.
 */
import { lazy, Suspense, type ComponentType } from 'react';
import { createBrowserRouter, Navigate, type RouteObject } from 'react-router-dom';
import { AppShell } from './shell/AppShell';
import { RouteError } from './shell/RouteError';
import { RouteFallback } from './shell/RouteFallback';

function feature(load: () => Promise<{ default: ComponentType }>) {
  const Lazy = lazy(load);
  return (
    <Suspense fallback={<RouteFallback />}>
      <Lazy />
    </Suspense>
  );
}

const routes: RouteObject[] = [
  {
    path: '/',
    element: <AppShell />,
    errorElement: <RouteError />,
    children: [
      { index: true, element: <Navigate to="/registry" replace /> },
      { path: 'registry/*', element: feature(() => import('@/features/registry/routes')) },
      { path: 'governance/*', element: feature(() => import('@/features/governance/routes')) },
      { path: 'admin/*', element: feature(() => import('@/features/admin/routes')) },
      { path: 'library/*', element: feature(() => import('@/features/library/routes')) },
      { path: '*', element: <Navigate to="/registry" replace /> },
    ],
  },
];

export const router = createBrowserRouter(routes);
export default routes;
